import React, { CSSProperties, useEffect, useRef } from 'react';
import Icon, { COLORS, ICONS } from '../icon';
import styled from 'styled-components';
import classNames from 'classnames';

const textFieldStyle: CSSProperties = {
	position: 'sticky',
	right: '8px',
	top: 'calc(50% - 16px)' // button is 32px high 10px padding + 12px icon
}

const imageFieldStyle: CSSProperties = {
	position: 'relative',
	marginLeft: '8px'
}

const ButtonContainer = styled.button`
	z-index: 1;
	background: rgba(255,255,255,0.05);
	border-radius: 100px;
	padding: 11px;
	line-height: 0px;

	&:hover {
		background: rgba(255, 255, 255, 0.1);
	}

	&:active {
		background: rgba(255,255,255,0.04);
	}

	&.disabled {
		pointer-events: none;
	}
`

const LockContainer = styled.div`
	height: 16px;
	position: absolute;
	right: -32px;
`

interface OwnProps {
	callback: () => void;
	imageField?: boolean;
	canShow?: boolean;
	forceShow?: boolean;
	disabled?: boolean;
	showLock?: boolean;
}

export default function InputClearButton(props: OwnProps) {
	const onClickHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
		props.callback();
	}

	if (props.showLock) return <LockContainer style={textFieldStyle}>
		<Icon name={ICONS.LOCK} color={COLORS.TEXT_GRAY_400} size={16} />
	</LockContainer>

	return <ButtonContainer 
		onClick={onClickHandler}
		style={props.imageField ? imageFieldStyle : textFieldStyle}
		className={classNames(`input-field-clear-btn`, {
			'can-show': props.canShow,
			'force-show': props.forceShow,
			'disabled': props.disabled
		})}
	>

		<Icon name={ICONS.TRASH} size={10} color={COLORS.WHITE} />
	</ButtonContainer>
}
